export default "__VITE_ASSET__DJ6K2sSd__"